export const clearCache = function () {
  Turbo.cache.clear()
}
